const $ = require('jquery');

$('.pager').each(function(){
	var trigger = $(this);
	trigger.click(function (e) {

		// deactivate active tab
		$('.pager.active').removeClass('active');
		var assessments = $('#assessments');
		assessments.find('.assessment.active').removeClass('active');

		// add the appropriate class to the wrapper
		var parent = $('#focus_areas_box');
		parent.attr('class', trigger.attr('class'));
		parent.removeClass('pager');

		// get a processed name to use
		var cls = parent.attr('class');

		// set the correct focus for border-color
		assessments.find('.assessment.' + cls).eq(0).addClass('active');

		// reenable some styling
		parent.addClass('row');

		// activate the active tab
		trigger.addClass('active');

		e.preventDefault();
	});
});
